module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-27@2x-99a91201639ddaeb13a444ee0cf2dfcd.png";